import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus } from 'lucide-react';
import api from '@/lib/api';
import { inr } from '@/lib/format';
import Loader from '@/components/common/Loader';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

export default function Inspiration() {
  const [products, setProducts] = useState([]);
  const [images, setImages] = useState([]);
  const [active, setActive] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    api.get('/home').then((r) => setImages(r.data.inspiration || [])).catch(() => {});
    api.get('/products', { params: { limit: 24, sort: 'featured' } }).then((r) => setProducts(r.data.items)).catch(() => {});
  }, []);

  if (!images.length) return <Loader />;

  const looks = images.map((img, i) => ({ image: img, tags: products.slice(i * 2, i * 2 + 3) }));

  return (
    <div>
      <div className="border-b border-border bg-white"><div className="container-gaze py-8 text-center"><p className="eyebrow mb-2">Inspiration Gallery</p><h1 className="font-display text-4xl sm:text-5xl">Shop the Look</h1><p className="mx-auto mt-2 max-w-xl text-sm text-muted-foreground">Editorial spaces styled by Gaze. Tap any look to shop the pieces inside it.</p></div></div>
      <div className="container-gaze py-8">
        <div className="columns-2 gap-4 sm:columns-3 lg:columns-4 [column-fill:_balance]">
          {looks.map((look, i) => (
            <button key={i} onClick={() => setActive(look)} data-testid="inspiration-gallery-tile" className="group relative mb-4 block w-full break-inside-avoid overflow-hidden rounded-2xl">
              <img src={look.image} alt="Look" loading="lazy" className={`w-full object-cover transition duration-700 group-hover:scale-105 ${i % 3 === 0 ? 'aspect-[3/4]' : 'aspect-square'}`} />
              <div className="absolute inset-0 bg-black/0 transition group-hover:bg-black/20" />
              <span className="absolute bottom-3 left-3 inline-flex items-center gap-1 rounded-full bg-white/90 px-3 py-1.5 text-xs font-semibold backdrop-blur"><Plus size={13} /> Shop the Look</span>
            </button>
          ))}
        </div>
      </div>

      <Dialog open={!!active} onOpenChange={(o) => !o && setActive(null)}>
        <DialogContent className="max-w-3xl" data-testid="shop-the-look-dialog">
          <DialogHeader><DialogTitle>Shop the Look</DialogTitle></DialogHeader>
          {active && (
            <div className="grid gap-5 sm:grid-cols-2">
              <img src={active.image} alt="Look" className="aspect-[4/5] w-full rounded-xl object-cover" />
              <div className="space-y-3">
                {active.tags.map((p) => (
                  <button key={p.id} onClick={() => { setActive(null); navigate(`/product/${p.slug}`); }} className="flex w-full items-center gap-3 rounded-xl border border-border p-2 text-left hover:bg-[hsl(var(--gaze-ivory))]">
                    <img src={p.images[0]} alt={p.name} className="h-14 w-14 rounded-lg object-cover" />
                    <div className="flex-1"><p className="text-sm font-medium">{p.name}</p><p className="text-sm font-semibold">{inr(p.price)}</p></div>
                  </button>
                ))}
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
}
